declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    props?: Boolean;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  let System: System;
}
import test from "../views/test.vue";
import login from "../views/login.vue";
import signUp from "../views/signUp.vue";
import forgot from "../views/forgot.vue";
import reset from "../views/resetPassword.vue";
import confirmEmail from "../views/confirmEmail.vue";
import completeRegistration from "../views/completeRegistration.vue";
import createBillingAccount from "../views/createBillingAccount.vue";
import main from "../views/main.vue";

export const lockingRouter = {
  path: "/locking",
  name: "locking",
  component: () => import("../components/lockscreen/components/locking-page.vue")
};
export const testRouter: Router = {
  path: "/test",
  name: "test",
  meta: {
    title: "Test"
  },
  component: test
};
export const loginRouter: Router = {
  path: "/",
  name: "login",
  meta: {
    title: "LogIn"
  },
  component: login
};
export const signUpRouter: Router = {
  path: "/signup",
  name: "signUp",
  meta: {
    title: "Sign Up"
  },
  component: signUp
};
export const forgotPasswordRouter: Router = {
  path: "/forgot",
  name: "forgot",
  meta: {
    title: "Forgot Password"
  },
  component: forgot
};
export const resetPasswordRouter: Router = {
  path: "/reset",
  name: "reset",
  meta: {
    title: "Reset Password"
  },
  component: reset
};
export const confirmEmailRouter: Router = {
  path: "/ConfirmEmail",
  name: "confirmEmail",
  meta: {
    title: "Confirm Email Address"
  },
  component: confirmEmail
};
export const completeRegistrationRouter: Router = {
  path: "/completeRegistration",
  name: "completeRegistration",
  meta: {
    title: "Complete Registration"
  },
  component: completeRegistration
};
export const createBillingAccountRouter: Router = {
  path: "/createAccount",
  name: "createBillingAccount",
  meta: {
    title: "Create Account"
  },
  component: createBillingAccount
};
export const otherRouters: Router = {
  path: "/main",
  name: "main",
  permission: "",
  meta: { title: "ManageMenu" },
  component: main,
  children: []
};

export const launchpadRouters: Router = {
  path: "/home",
  name: "home",
  meta: { title: "Home" },
  component: () => import("../components/master/master.vue"),
  children: [
    { path: "support", meta: { title: "Support" }, name: "support", props: true, component: () => import("../views/support.vue") },
    { path: "dashboard", meta: { title: "Dashboard" }, name: "dashboard", props: true, component: () => import("../views/dashboard.vue") },
    { path: "teams", meta: { title: "Teams" }, name: "teams", props: true, component: () => import("../views/teams.vue") },
    { path: "team/:id", meta: { title: "Team Home" }, name: "team", props: true, component: () => import("../views/team.vue") },
    { path: "goals", meta: { title: "Targets" }, name: "goals", props: true, component: () => import("../views/goals.vue") },
    { path: "reviews", meta: { title: "Reviews" }, name: "reviews", props: true, component: () => import("../views/reviews.vue") },
    { path: "projects", meta: { title: "Projects" }, name: "projects", props: true, component: () => import("../views/projects.vue") },
    { path: "project/:id", meta: { title: "Project Home" }, name: "project", props: true, component: () => import("../views/project.vue") },
    { path: "courses", meta: { title: "Courses" }, name: "courses", props: true, component: () => import("../views/courses.vue") },
    { path: "users", meta: { title: "Users" }, name: "users", props: true, component: () => import("../views/users.vue") },
    { path: "user/:id", meta: { title: "User" }, name: "user", props: true, component: () => import("../views/user.vue") },
    { path: "assignments", meta: { title: "My Assignments" }, name: "assignments", component: () => import("../views/assignments.vue") },
    { path: "reportcard", meta: { title: "Report Card" }, name: "reportcard", component: () => import("../views/report-card.vue") },
    { path: "join", meta: { title: "Join" }, name: "join", component: () => import("../views/join.vue") },
    { path: "joinproject", meta: { title: "Join Project" }, name: "joinproject", component: () => import("../views/project-join.vue") },
    { path: "joinreview", meta: { title: "Join Review" }, name: "joinreview", component: () => import("../views/review-join.vue") },
    { path: "goal/:id", meta: { title: "Target Home" }, name: "goal", props: true, component: () => import("../views/goal.vue") },
    { path: "review/:id", meta: { title: "Review Home" }, name: "review", props: true, component: () => import("../views/review.vue") },
    { path: "activate", meta: { title: "Activate your account" }, name: "activateaccount", props: true, component: () => import("../views/activate-account.vue") },
    { path: "adminland", meta: { title: "Adminland" }, name: "adminland", props: true, component: () => import("../views/adminland.vue") }
  ]
};

export const appRouters: Array<Router> = [
  {
    path: "/setting",
    name: "setting",
    permission: "",
    meta: { title: "ManageMenu" },
    icon: "&#xe68a;",
    component: main,
    children: [
      {
        path: "appUser",
        permission: "Pages.Users",
        meta: { title: "Users" },
        name: "appUser",
        component: () => import("../views/setting/user/user.vue")
      },
      {
        path: "role",
        permission: "Pages.Roles",
        meta: { title: "Roles" },
        name: "role",
        component: () => import("../views/setting/role/role.vue")
      },
      {
        path: "tenant",
        permission: "Pages.Tenants",
        meta: { title: "Tenants" },
        name: "tenant",
        component: () => import("../views/setting/tenant/tenant.vue")
      }
    ]
  }
];
export const routers = [
  testRouter,
  loginRouter,
  signUpRouter,
  forgotPasswordRouter,
  resetPasswordRouter,
  confirmEmailRouter,
  completeRegistrationRouter,
  createBillingAccountRouter,
  lockingRouter,
  ...appRouters,
  otherRouters,
  launchpadRouters
];
